<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn v-if="page.isNew && $check(user, ['reporttypes.create'])" type="button" elevation="0"
                            color="primary" @click=create()>Salvar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/analise-relatorio">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-form ref="form" v-model="dataForm.validForm" v-if="page.isNew">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="4">
                                            <v-text-field dense id="name" label="Nome" v-model="dataset.data.name"
                                                required :rules="[$rules.required]" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-checkbox label="Comparar com QGC"
                                                v-model="dataset.data.compareQGC"></v-checkbox>
                                        </v-col>
                                    </v-row>
                                </v-card-text>

                                <v-card-text>
                                    <v-divider>

                                    </v-divider>
                                </v-card-text>

                                <v-card-text v-for="(item, index) in groups" :key="index">

                                    <span class="ml-4"><strong>Grupo {{ index + 1 }}</strong></span>

                                    <v-col v-if="item.conditions.length > 0" cols="12" sm="8">
                                        <v-select dense class="mr-2" :items="dataset.reports" item-value="id"
                                            item-text="name" v-model="item.whenReport" return-object label="Relatório"
                                            outlined hide-details="auto"></v-select>
                                    </v-col>

                                    <ConditionGroup :mainReport="item.whenReport ? item.whenReport : null" class="mt-2"
                                        :conditions="item.conditions" :dataset="dataset" :operators="operators" />

                                    <!-- Botão para adicionar nova condição principal -->
                                    <v-btn class="ml-4 mt-4 mb-4" color="#B39DDB" small
                                        @click="addCondition(item.conditions)">
                                        Adicionar Condição
                                    </v-btn>

                                    <v-divider></v-divider>

                                </v-card-text>

                                <v-card-text>
                                    <v-row>
                                        <v-col>
                                            <v-text-field v-model="customExpression" label="Expressão personalizada"
                                                outlined dense class="mt-4"
                                                placeholder="Ex: (Grupo1 + Grupo2) / Grupo3"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col>
                                            <v-btn class="mt-4" color="accent" small @click="addGroup()">
                                                Adicionar Grupo
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>

        <v-row>
            <v-col>
                <v-card>
                    <v-card-title class="headline">Resultados da Análise</v-card-title>
                    <v-card-text>
                        <v-data-table :headers="headers" :items="dataset.records" item-value="registration" dense
                            no-data-text="Nenhum resultado encontrado">
                            <template v-slot:item="{ item, index }">
                                <tr v-if="item.registration == 'UNKNOWN'" style="background: var(--v-error-base);">
                                    <td class="font-weight-bold">
                                        <v-btn icon @click="toggleExpanded(index)">
                                            <v-icon v-if="expandedIndex === index">mdi-chevron-up</v-icon>
                                            <v-icon v-else>mdi-chevron-down</v-icon>
                                        </v-btn>
                                        SEM REGISTRO
                                    </td>
                                    <td>{{ item.user_event_amount | currency }}</td>
                                    <td v-if="item.user_creditor">{{ item.user_creditor.amount | currency }}</td>
                                    <td v-else>N/A</td>
                                    <td>{{ item.totalValue | currency }}</td>
                                    <td>{{ item.total }}</td>
                                </tr>
                                <tr v-else>
                                    <td class="font-weight-bold">
                                        <v-icon color="accent"
                                            v-if="(item.user_creditor && item.totalValue == item.user_creditor.amount) || item.totalValue == item.user_event_amount">mdi-check-circle-outline</v-icon>
                                        <v-icon color="warning" v-else>mdi-alert-circle-outline</v-icon>
                                        <v-btn icon @click="toggleExpanded(index)">
                                            <v-icon v-if="expandedIndex === index">mdi-chevron-up</v-icon>
                                            <v-icon v-else>mdi-chevron-down</v-icon>
                                        </v-btn>
                                        {{ item.registration }}
                                    </td>
                                    <td>{{ item.user_event_amount | currency }}</td>
                                    <td v-if="item.user_creditor">{{ item.user_creditor.amount | currency }}</td>
                                    <td v-else>N/A</td>
                                    <td>{{ item.totalValue | currency }}</td>
                                    <td>{{ item.total }}</td>
                                </tr>
                                <tr v-if="expandedIndex === index">
                                    <td>
                                        <v-row v-for="(record, rIndex) in item.records" :key="rIndex">
                                            <v-col cols="12" sm="12">
                                                <br v-if="rIndex == 0">
                                                <span> <strong>Relatório:</strong> {{ record.report.name }}</span>
                                                <br>
                                                <span><strong>Coluna:</strong> {{ record.result.column.label }}</span>
                                                <br>
                                                <span> <strong>Valor:</strong> {{ record.result.value | currency
                                                }}</span>
                                                <br>
                                                <span><strong> Associação:</strong> {{ record.result.associationValue ||
                                                    "N/A" }}</span>
                                                <br>
                                                <span> <strong>Grupo:</strong> {{ record.group }}</span>
                                                <br>
                                                <br>
                                                <v-icon color="primary">mdi-file-tree</v-icon>
                                                <span class="ml-2 font-weight-bold">Rastreamento:
                                                </span>
                                                <br>
                                                <span v-for="(trace, tIndex) in record.result.trace" :key="tIndex">
                                                    <v-icon color="green">mdi-arrow-right</v-icon>
                                                    <span class="ml-2">
                                                        {{ trace.report.name }} → {{ trace.column.label }}
                                                        ({{ trace.columnValue }})
                                                    </span>
                                                    <br>
                                                </span>
                                                <br>
                                                <br>
                                                <v-divider v-if="(rIndex + 1) != item.records.length"></v-divider>
                                            </v-col>
                                        </v-row>
                                        <!-- <v-list>
                                                <v-list-item-group>
                                                    <v-list-item v-for="(record, rIndex) in item.records" :key="rIndex">
                                                        <v-list-item-content>
                                                            <v-list-item-title class="font-weight-bold">
                                                                Relatório: {{ record.report.name }}
                                                            </v-list-item-title>
                                                            <v-list-item-subtitle>
                                                                <strong>Coluna:</strong> {{ record.result.column.label
                                                                }}
                                                            </v-list-item-subtitle>
                                                            <v-list-item-subtitle>
                                                                <strong>Valor:</strong> {{ record.result.value }}
                                                            </v-list-item-subtitle>
                                                            <v-list-item-subtitle>
                                                                <strong> Associação:</strong> {{
                                                                    record.result.associationValue || "N/A" }}
                                                            </v-list-item-subtitle>
                                                            <v-list-item>
                                                                <v-icon color="primary">mdi-file-tree</v-icon>
                                                                <span class="ml-2 font-weight-bold">Rastreamento:
                                                                </span>
                                                            </v-list-item>
                                                            <v-list-item v-for="(trace, tIndex) in record.result.trace"
                                                                :key="tIndex">
                                                                <v-icon color="green">mdi-arrow-right</v-icon>
                                                                <span class="ml-2">
                                                                    {{ trace.report.name }} → {{ trace.column.label }}
                                                                    ({{ trace.columnValue }})
                                                                </span>
                                                            </v-list-item>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list-item-group>
                                            </v-list> -->
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import axios from "axios"

import reportColumnTypes from '@/common/data/report-column-types.data'
import ConditionGroup from "@/components/ConditionGroup.vue";

export default {
    name: "ReportTypeDetails",

    components: { ConditionGroup },

    data: () => ({
        user: null,
        page: {
            isNew: false,
            title: "",
        },
        rule: {
            column1: '',
            operator: '',
            column2: ''
        },
        dataset: {
            reportColumnTypes: reportColumnTypes,
            breadcrumbItems: [],
            loading: false,
            reports: [],
            records: [],
            data: {
                columns: [],
                rules: []
            },
        },
        headers: [
            { text: "CPF/CNPJ", value: "registration", align: "start" },
            { text: "Valor pedido hab/div", value: "user_event_amount" },
            { text: "Valor QGC", value: "user_creditor" },
            { text: "Valor total (análise)", value: "totalValue" },
            { text: "Total de Registros", value: "total" }
        ],
        expandedIndex: null,
        groups: [],
        operators: [
            { id: "=", label: "Igual" },
            { id: "!=", label: "Diferente" },
            { id: ">", label: "Maior que" },
            { id: "<", label: "Menor que" },
            { id: "IN", label: "Existe" },
        ],
        mathOperators: [
            { id: "+", label: "Soma (+)" },
            { id: "-", label: "Subtração (-)" },
            { id: "*", label: "Multiplicação (*)" },
            { id: "/", label: "Divisão (/)" }
        ],
        customExpression: "",
        dataForm: {
            validForm: true,
            addLoading: false,
        },
    }),

    created() {
        this.setPage();
        this.listBreadCrumbItems();
        this.loadData();
    },

    methods: {

        goBack() {
            this.$router.replace("/analise-relatorio");
        },

        async loadData() {
            this.user = this.$root.user.data || this.$root.user;

            await this.load();
            await this.loadReports();

        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = this.page && this.page.isNew ? "Criar análise" : "Detalhes da análise";
        },

        randomColor() {
            const r = () => Math.floor(256 * Math.random());

            return `rgb(${r()}, ${r()}, ${r()})`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Análises de Relatórios",
                disabled: false,
                to: "/analise-relatorio",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.title,
                disabled: true,
                exact: true,
            });
        },

        async load() {
            console.log('this. page ', this.page)
            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/admin/report-analysis/${this.$route.params.id}`);

                this.dataset.data = result.data.content;
                this.dataset.records = JSON.parse(result.data.content.result)

                this.dataset.records = this.dataset.records.sort((a, b) => {
                    if (a.registration === "UNKNOWN") return -1;
                    if (b.registration === "UNKNOWN") return 1;
                    return 0; // Mantém a ordem original dos outros registros
                });
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            }
        },

        async loadReports() {
            try {
                const result = await axios.get(`/api/admin/report-files`, { limit: 10000 });

                this.dataset.reports = result.data.content.data;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar dados do modelo?',
                title: 'Atualizar modelo',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar',
                },
            });

            if (!proceedAction) return;

            const payload = await this.buildPayload();

            console.log("payload: ", payload)

            try {
                const response = await axios.patch(`/api/admin/report-analysis/${this.$route.params.id}`, payload, {
                    headers: { 'Content-Type': 'application/json' },
                });

                this.$dialog.notify.info('Análise atualizada com sucesso!', {
                    position: 'top-right',
                    timeout: 2000,
                });

                this.goBack();
            } catch (error) {
                this.$dialog.notify.error('Erro ao atualizar a análise.', {
                    position: 'top-right',
                    timeout: 2000,
                });
            }
        },

        async create() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja criar uma nova análise?',
                title: 'Criar análise',
                actions: {
                    false: 'Cancelar',
                    true: 'Criar',
                },
            });

            if (!proceedAction) return;

            console.log('rules ', this.dataset.data)

            // const payload = await this.buildPayload();

            const result = this.generateJSON()
            console.log('result ', result)

            try {
                const response = await axios.post('/api/admin/report-analysis', result, {
                    headers: { 'Content-Type': 'application/json' },
                });

                this.$dialog.notify.info('Análise criada com sucesso!', {
                    position: 'top-right',
                    timeout: 2000,
                });

                this.goBack();
            } catch (error) {
                // TODO: melhorar
                this.$dialog.notify.error('Erro ao criar a análise.', {
                    position: 'top-right',
                    timeout: 2000,
                });
            }
        },

        async executeAnalysis() {
            const result = this.generateJSON()
            console.log('result ', result)
            // if (!this.$refs.form.validate()) return;

            // const proceedAction = await this.$dialog.confirm({
            //     text: 'Deseja executar a análise?',
            //     title: 'Criar análise',
            //     actions: {
            //         false: 'Cancelar',
            //         true: 'Criar',
            //     },
            // });

            // if (!proceedAction) return;

            try {
                const response = await axios.post(`/api/admin/report-analysis/execute/${this.$route.params.id}`, { analysis: result }, {
                    headers: { 'Content-Type': 'application/json' },
                });

                this.$dialog.notify.info('Análise iniciada com sucesso!', {
                    position: 'top-right',
                    timeout: 2000,
                });
            } catch (error) {
                // TODO: melhorar
                this.$dialog.notify.error('Erro ao iniciar a análise.', {
                    position: 'top-right',
                    timeout: 2000,
                });
            }
        },


        async buildPayload() {
            return {
                name: this.dataset.data.name,
                columns: this.dataset.data.columns,
                rules: this.dataset.data.rules
            };
        },

        getColumnsRules() {
            return this.dataset.data.columns.filter((x) => x.id && x.type == 4);
        },

        addColumn() {
            this.dataset.data.columns.push({ key: '', label: '', type: 1 })
        },

        removeColumn(index) {
            this.dataset.data.columns.splice(index, 1)
        },

        addGroup() {
            this.groups.push({ conditions: [] })
        },

        addCondition(parentConditions) {
            parentConditions.push({
                rules: [
                    {
                        logicOperator: null,
                        whenReport: null,
                        whenColumn: null,
                        whenOperator: null,
                        whenValue: null,
                        isCompareReport: false,
                        compareReport: null,
                        compareColumn: null,
                    }
                ],
                thenColumnValue: null,
                thenColumnAssociation: null,
                conditions: [],
            });
        },

        generateJSON() {
            const convertCondition = (condition) => {
                return {
                    type: condition.isElse ? "SENÃO" : condition.isElseIf ? "SENÃO SE" : "SE",
                    rules: condition.rules.map(rule => ({
                        logicOperator: rule.logicOperator || null,
                        whenColumn: rule.whenColumn || null,
                        whenOperator: rule.whenOperator || null,
                        whenValue: rule.isCompareReport
                            ? { compareWith: rule.compareReport || null, column: rule.compareColumn || null }
                            : rule.whenValue,
                    })),
                    then: condition.thenColumnValue ? {
                        report: condition.thenReport ? condition.thenReport : null,
                        column: condition.thenColumnValue,
                        association: condition.thenColumnAssociation || null,
                        value: condition.thenValue || null
                    } : null,
                    else: condition.elseColumnValue ? {
                        report: condition.elseReport ? condition.elseReport.id : null,
                        column: condition.elseColumnValue,
                        association: condition.elseColumnAssociation || null,
                        value: condition.elseValue || condition.elseValue == 0 ? condition.elseValue : null
                    } : null,
                    subConditions: condition.conditions.length > 0 ? condition.conditions.map(sub => convertCondition(sub)) : [],
                };
            };

            const groups = this.groups.map(group => ({
                report: group.whenReport ? group.whenReport.id : null,
                conditions: group.conditions.map(condition => convertCondition(condition))
            }));

            const resultJson = {
                name: this.dataset.data.name,
                compareQGC: this.dataset.data.compareQGC,
                customExpression: this.customExpression || null,
                groups
            };

            // console.log("JSON Gerado:", JSON.stringify(resultJson, null, 2));
            return resultJson;
        },

        toggleExpanded(index) {
            this.expandedIndex = this.expandedIndex === index ? null : index;
        }

    },


};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    font-family: 'Raleway';
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    font-family: 'Raleway';
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.main-text {
    font-size: 16px;
    color: #000;
}

.caption-text2 {
    font-size: 12px;
    font-weight: bold;
    color: #444;
    margin-top: -5px;
}
</style>